import { createAction } from 'redux-actions';

import getTypes from './types';

const getActions = storeName => {
    const types = getTypes(storeName);
    const saveDistrictsByCity = createAction(types.SAVE_DISTRICTS_BY_CITY);
    const setCityReferredToCurrentDistricts = createAction(
        types.SET_CITY_REFERRED_TO_CURRENT_DISTRICTS,
    );
    const saveNeighborhoodsByDistrict = createAction(types.SAVE_DISTRICTS_BY_CITY);
    const setDistrictReferredToCurrentNeighborhoods = createAction(
        types.SET_CITY_REFERRED_TO_CURRENT_DISTRICTS,
    );

    return {
        saveDistrictsByCity,
        setCityReferredToCurrentDistricts,
        saveNeighborhoodsByDistrict,
        setDistrictReferredToCurrentNeighborhoods,
    };
};

export default getActions;
